function newSessionId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

/**
 * The current search session id, shared by the search API client (which
 * tags every query with `sid`) and `SearchCommitAnalyticsApi` (which tags
 * committed searches and outcomes with it). A session lasts until a result
 * click or an abandonment ends it.
 */
export class SearchSessionTracker {
  private sessionId?: string;

  constructor(private readonly createId: () => string = newSessionId) {}

  /** Returns the current session id, starting a session if needed. */
  current(): string {
    this.sessionId ??= this.createId();
    return this.sessionId;
  }

  /** Ends the current session; the next search starts a new one. */
  end(): void {
    this.sessionId = undefined;
  }
}

/** App-wide tracker used by the search client and the analytics decorator. */
export const searchSession = new SearchSessionTracker();
